import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalContent } from 'components/site/modals/ModalWrapper/ModalContent';
import { ModalWrapperPC } from 'components/site/modals/ModalWrapper/ModalWrapperPC';
import { motion } from 'framer-motion';
import { EColors, EGrads, EHovers } from 'libs/styles/styling';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { useContext, useEffect } from 'react';
import { CtxModal } from 'session/ctxModal';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ModalWrapper = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const isWide = useIsWide();

    useEffect(() => {
        const keyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                ctxModal.setModal(null);
            }
            // else if (e.key === 'Enter') {
            //     ctxModal.setModal(null);
            // }
        };
        window.addEventListener('keydown', keyDown);
        return () => {
            window.removeEventListener('keydown', keyDown);
        };
    }, []);

    return (
        <S_ModalWrapper>
            <S_Overlay
                className={props.className}
                onClick={() => {
                    ctxModal.setModal(null);
                }}
            />
            {!isWide && (
                <>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.1 }}
                    >
                        <S_Close
                            onClick={() => {
                                ctxModal.setModal(null);
                            }}
                        >
                            <FontAwesomeIcon icon={['fal', 'xmark']} />
                        </S_Close>
                    </motion.div>
                    <motion.div
                        initial={{ y: '100vh' }}
                        animate={{ y: '70px' }}
                        transition={{
                            delay: 0.1,
                            y: { duration: 0.2 },
                            default: { ease: 'linear' }
                        }}
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            zIndex: 1010000,
                            boxSizing: 'border-box',
                            padding: '0 10px'
                        }}
                    >
                        <S_MobileModal $height={window.innerHeight - 70}>
                            <ModalContent />
                        </S_MobileModal>
                    </motion.div>
                </>
            )}
            {isWide && <ModalWrapperPC />}
        </S_ModalWrapper>
    );
};

const S_ModalWrapper = styled.div`
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    /* z-index: 1000000; */
    z-index: 3000000;
    display: flex;
    justify-content: center;
`;

const S_Overlay = styled.div`
    width: 100%;
    height: 100%;
    z-index: 1000000;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    top: 0;
    left: 0;
    @media only screen and (min-width: 1260px) {
        background: rgba(0, 0, 0, 0.8);
    }
`;

const S_MobileModal = styled.div<{ $height: number }>`
    width: 100%;
    height: ${(props) => props.$height}px;
    border-top-right-radius: 7px;
    border-top-left-radius: 7px;
    overflow: hidden;
`;

const S_Close = styled.div`
    position: absolute;
    top: 15px;
    right: 10px;
    z-index: 1000001;
    color: ${EColors.DARK};
    background: ${EGrads.ACC1_GRAD};
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
    font-size: 20px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    &:hover {
        box-shadow: ${EHovers.LIGHT2}, 0px 10px 30px rgba(0, 0, 0, 0.3);
    }
`;
